export default __webpack_public_path__ + "static/media/reveal-2.26bd4d3a.png";